function Beneficios() {
  return (
    <section id="beneficios" className="benefits">
        <div className="container">
            <h2>Por que alugar com a GMED?</h2>
            <div className="benefit-grid">
                <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <h3>Custo-benefício</h3>
                    <p>Evite altos investimentos com a compra de equipamentos.</p>
                </div>
                <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <h3>Segurança e higiene</h3>
                    <p>Todos os itens são higienizados e revisados com rigor.</p>
                </div>
                <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <h3>Entrega rápida</h3>
                    <p>Agilidade na entrega para quem precisa com urgência.</p>
                </div>
                <div className="benefit-item">
                    <i className="fas fa-check-circle"></i>
                    <h3>Praticidade</h3>
                    <p>Locação simples, sem burocracia e com suporte especializado.</p>
                </div>
            </div>
        </div>
    </section>
);
}

export default Beneficios;
